module.exports = __webpack_public_path__ + "static/media/Klavika-Light.61a2f1b8.woff";